import React, {useState} from "react";
import PropTypes from "prop-types";
import {ACheckbox} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import DeleteModal from "../../../components/DeleteModal";
import {bulkDeleteIncidents} from "../../../store/features/incidentsSlice";

const BulkActionDeleteModal = ({incidents, open, setOpen}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleDeleteIncidents = () => {
    if (incidents.length > 0) {
      dispatch(bulkDeleteIncidents(incidents.map((incident) => incident.id)));
      setIsChecked(false);
      setOpen(false);
    }
  };

  return (
    <DeleteModal
      disabled={!isChecked}
      open={open}
      setOpen={setOpen}
      onDelete={() => handleDeleteIncidents()}
      title={t("incidents.bulkDelete.modalTitle", {
        count: incidents?.length
      })}>
      <p className="ma-0">
        {t("incidents.bulkDelete.bulkDeleteConfirmation", {
          count: incidents?.length
        })}
      </p>
      <p className="ma-0">{t("incidents.bulkDelete.undone")}</p>
      <div className="observable-checkbox mt-2">
        <ACheckbox
          data-testid={"BulkActionDeleteModal-Checkbox"}
          id="bulkDeleteCheckbox"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}>
          <span>{t("incidents.bulkDelete.confirmationCheckbox")}</span>
        </ACheckbox>
      </div>
    </DeleteModal>
  );
};

BulkActionDeleteModal.propTypes = {
  incidents: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
};

export default BulkActionDeleteModal;
